export const SUBJECTS = [
  "Türkçe",
  "İngilizce",
  "Matematik",
  "Fen Bilimleri",
  "Sosyal Bilimler",
  "Tarih",
  "Coğrafya",
  "Fizik",
  "Kimya",
  "Biyoloji",
];

export const CLASS_LEVELS = [
  "İlkokul",
  "Ortaokul",
  "9. Sınıf",
  "10. Sınıf",
  "11. Sınıf",
  "12. Sınıf",
];

export const LESSON_TYPES = [
  { value: "online", label: "Online" },
  { value: "in_person", label: "Yüz Yüze" },
];

export const LESSON_TYPE_LABEL = {
  online: "Online",
  in_person: "Yüz Yüze",
};
